/**
 * The AnyAPI mark's geometry, drawn by `BrandMark` on screen and by the usage
 * report's PDF logo. One copy, so the two cannot drift: a price tag filled with
 * the accent, a ring for the tag's hole, and a three-stroke asterisk, both in
 * the accent's ink.
 */
export const BRAND_MARK = {
  viewBox: '8.3 4 36 36',
  tag: 'M26 6h12a4 4 0 0 1 4 4v12L27.7 36.3a2.4 2.4 0 0 1-3.4 0L11.7 23.7a2.4 2.4 0 0 1 .1-3.5Z',
  ring: { cx: 34, cy: 13.5, r: 2.9, strokeWidth: 2.4 },
  /** One vertical stroke, repeated at each rotation about the asterisk centre. */
  stroke: { x1: 24.5, y1: 17, x2: 24.5, y2: 29, strokeWidth: 2.9 },
  strokeRotations: [0, 60, 120],
  strokeCentre: '24.5 23',
} as const;

/** The SVG transform that turns the base stroke into one asterisk arm. */
export const brandMarkStrokeTransform = (degrees: number): string | undefined =>
  degrees === 0 ? undefined : `rotate(${degrees} ${BRAND_MARK.strokeCentre})`;
